FormFields = require './internal/form-fields'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('credit_card')
{ forTemplate } = require('app/common/lib/util/i18n')
{ Checkbox } = require('@trello/nachos')
{ PurchaseFormIds } = require('@trello/webdriverio-tests')

format = forTemplate('credit_card')

module.exports = class extends React.Component
  displayName: 'TermsOfServiceComponent'

  formFields: ['acceptTOS']
  requiredFields:
    acceptTOS: true

  render: t.renderable ->
    { errorField } = @props
    isError = errorField == 'acceptTOS'

    render = ({ formState, setFormState }) ->
      onChange = (e) =>
        setFormState(acceptTOS: e.target.checked)

      checked = formState.acceptTOS

      t.div id: 'divAcceptTOS', ->
        t.createElement Checkbox, {
          name: 'tos'
          isChecked: checked
          isInvalid: isError
          label: React.createElement 'span', {
            dangerouslySetInnerHTML: {
              __html: format 'i-accept-the-terms-of-service-and-the-privacy-policy'
            }
          }
          onChange
        }
        if isError
          t.p class: t.classify('u-form-error': true, error: true), 'data-test-id': PurchaseFormIds.TermsOfServiceValidationError, ->
            t.format 'you-must-accept-the-terms-of-service-and-privacy-policy'

    t.tag FormFields, {
      render
      @formFields
      @requiredFields
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      initialState: {
        acceptTOS: false
      }
    }
